import React from 'react';
import { CognitoState } from 'react-cognito';
import concat from 'lodash/concat';
import eq from 'lodash/eq';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';

export function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

// Copied from https://github.com/reactjs/redux/blob/master/src/compose.js
export function compose(...funcs) {
  if (funcs.length === 0) {
    return arg => arg;
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

export function sleepAsync(ms) {
  return new Promise(function(resolve, reject) {
    setTimeout(resolve, ms);
  });
}

export async function loginStabilized(getState) {
  while (true) {
    const state = getState();
    if (state.cognito.state === CognitoState.LOGGING_IN) {
      await sleepAsync(100);
    } else if (state.cognito.state === CognitoState.AUTHENTICATED) {
      await sleepAsync(100);
    } else {
      return;
    }
  }
}

export function validEmail(address) {
  const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(address);
}

export function propsEqual(props, nextProps, keys, compareFunc = eq) {
  if (typeof keys === undefined) {
    compareFunc = keys;
    keys = undefined;
  }

  if (keys === undefined) {
    const propKeys = Object.keys(props);
    const nextPropsKeys = Object.keys(nextProps);
    if (!isEqual(propKeys, nextProps)) {
      return false;
    }

    keys = uniq(concat(propKeys, nextPropsKeys));
  }

  for (let key of keys) {
    if (!compareFunc(props[key], nextProps[key])) {
      return false;
    }
  }

  return true;
}

export class MyPureComponent extends React.PureComponent {
  shouldComponentUpdate(nextProps, nextState) {
    const stateEqual = depthEqual(this.state, nextState);
    const propsEqual = depthEqual(this.props, nextProps, 2);

    if (stateEqual && propsEqual) {
      return false;
    }

    return true;
  }
}

export function depthEqual(objA, objB, depth = 1) {
  if (objA === objB) {
    return true;
  }

  if (depth === 0) {
    return false;
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  const nextDepth = Math.max(depth - 1, -1);
  for (let key of keysA) {
    if (!bHasOwnProperty(key) || !depthEqual(objA[key], objB[key], nextDepth)) {
      return false;
    }
  }

  return true;
}

export function noOp() {}



// WEBPACK FOOTER //
// ./src/lib/react.js